export default __webpack_public_path__ + "logo-TEST-desktop.svg";